<template>
	<div class="row">
        <div class="col-2 pl-0">Agent ：<br/><strong>{{showname}}</strong></div>
        <div class="col-2 pl-0">Real Games Credit：<br/><strong :id="'mainbalance'+showname">{{formatCurrency(balance)}}</strong></div>

        <div class="col pl-0">Share：<br/><strong>{{share}} %</strong></div>
        <div class="col pl-0">Rebate：<br/><strong>{{rebate}} %</strong></div>
        <div class="col pl-0">Status： <strong class="text-success">Enable</strong></div>
        <div class="col pl-0">Bet： <strong class="text-success">Enable</strong></div>
        <div class="col pl-0">Direct Agents:<br/><strong>{{diragent}}</strong></div>
        <div class="col pl-0">Direct Clients: <br/><strong>{{dirclient}}</strong></div>
      </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as TYPES from "@/store/mutation-types";

export default {
  name: "AgentInformation",
  props: {
    collections: {
      type: Array,
      required: true
    },
    balance : Number, 
    showname: String,
    rebate:String,
    diragent:String,
    share:String,
    dirclient:String
  },
  computed: {
    ...mapGetters(["allTabs","allAgents"]),
    getTabs() {
      return this.allTabs
    },
    getAllAgents(){
      return this.allAgents
    }
  },
  methods: {
    formatCurrency(value) {
          let val = (value/1).toFixed(2).replace(',', '.')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    newArray(){
      let that = this;
      let arr = that.getAllAgents,
      list = [];
     // debugger;
      var recurse = function (data) {
          function SelectAll(data){
              _.each(data, function(item){
                  item.IsSelected = true;
                  list.push(item);
                  SelectAll(item.children);
              });
              _.remove(data, function(x){
                return x.children
              });
          };
          SelectAll(data);
      }
      recurse(arr);
    
      return list;
    },
    getInfo(){
      
      //debugger;
        let newArray = this.newArray()
        let x = this.showname
       
        var results=_.filter(newArray,function(o){
          return o.username.toLowerCase().indexOf(this.showname)>-1;
        });

    }
  },
  created: function(){
      let that = this;
      let arr = that.getAllAgents 
  }

};
</script>